// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-container {
  width: 100%;
  text-align: center;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner-container .spinner {
  display: inline-block;
  width: 22px;
  height: 22px;
  border-width: 4px;
  border-style: solid;
  border-color: #f3f3f3;
  border-top-color: #ffc439;
  border-radius: 50%;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.option-spinner-container {
  text-align: center;
}

@-webkit-keyframes optionSpin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes optionSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.option-spinner-container .spinner {
  display: inline-block;
  width: 22px;
  height: 22px;
  border-width: 4px;
  border-style: solid;
  border-color: #f3f3f3;
  border-top-color: #8f8f8f;
  border-radius: 50%;
  -webkit-animation: optionSpin 2s linear infinite;
  animation: optionSpin 2s linear infinite;
}

.spinner-container.page-stub-spinner {
  margin-top: 10vh;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.spinner.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;EAChD,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".spinner-container {\n  width: 100%;\n  text-align: center;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.spinner-container .spinner {\n  display: inline-block;\n  width: 22px;\n  height: 22px;\n  border-width: 4px;\n  border-style: solid;\n  border-color: #f3f3f3;\n  border-top-color: #ffc439;\n  border-radius: 50%;\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n\n.option-spinner-container {\n  text-align: center;\n}\n\n@-webkit-keyframes optionSpin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes optionSpin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.option-spinner-container .spinner {\n  display: inline-block;\n  width: 22px;\n  height: 22px;\n  border-width: 4px;\n  border-style: solid;\n  border-color: #f3f3f3;\n  border-top-color: #8f8f8f;\n  border-radius: 50%;\n  -webkit-animation: optionSpin 2s linear infinite;\n  animation: optionSpin 2s linear infinite;\n}\n\n.spinner-container.page-stub-spinner {\n  margin-top: 10vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
